// app/features/ai-workflows/services_and_hooks/useRealTimePucNotifications.ts
"use client";

/**
 * PUC (personalized use case) status updates are delivered by a server-side
 * Supabase DB webhook (`app/api/personalized-use-cases/webhook/route.ts`),
 * which invalidates the relevant Next.js cache tag directly — see
 * `UPDATE_STRATEGY_CONFIG.useWebhookUpdates` in
 * `usePersonalizedUseCasesQueryHook.ts`. This replaced the previous
 * client-side Supabase Realtime `postgres_changes` subscription
 * (commit 575b9b6f) — that migration is complete and permanent, not a
 * crash workaround pending a re-enable.
 *
 * This hook is intentionally a no-op now. It previously opened a Realtime
 * channel with zero listeners attached (dead weight — a live WebSocket
 * that did nothing) as a placeholder for "future notifications." Kept as
 * a stable import so `app/(routes)/ai-workflows/page.tsx` doesn't need to
 * change; wire real listeners back in here only if a genuine client-push
 * use case (not covered by the webhook) shows up.
 */
export function useRealtimePucNotifications() {
  // no-op — see module doc above
}
